import { reducer as form } from 'redux-form';
import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import history from 'react/api/history';

import routes from 'react/api/reducers/routes.js';
import routeMonitor from 'react/api/reducers/routemonitor.js';
import filter from 'react/api/reducers/filter.js';
import eventNotifications from 'react/api/reducers/eventnotifications.js';
import pendingOrderAggregate from 'react/api/reducers/PendingOrderAggregate.js';
import pendingOrders from 'react/api/reducers/PendingOrders.js';

import configuration from 'react/api/reducers/configuration.js';
import features from 'react/api/reducers/features.js';
import tabs from 'react/api/reducers/tabs.js';

import auth from 'react/api/reducers/auth.js';
import user from 'react/api/reducers/user.js';
import recoverPassword from 'react/api/reducers/recoverPassword.js';
import passwordPolicies from 'react/api/reducers/passwordPolicies.js';
import logoffAlertModal from 'react/api/reducers/logoffAlertModal.js';
import i18n from 'react/api/reducers/i18n.js';
import modal from 'react/api/reducers/modal.js';
import resequenceHistory from 'react/api/reducers/resequenceHistory.js';

import stopDetailsPopup from 'react/api/reducers/stopDetailsPopup.js';
import routeSummary from 'react/api/reducers/routeSummary.js';
import licenseStatusModal from 'react/api/reducers/licenseStatusModal.js';
import taskScheduler from 'react/api/reducers/taskScheduler.js';
import dashboardAnalytics from 'react/api/reducers/dashboardAnalytics.js';
import routeSurveyModal from 'react/api/reducers/routeSurveyModal.js';
import photoGallery from 'react/api/reducers/photoGallery.js';
import stockSummaryModal from 'react/api/reducers/stockSummaryModal.js';
import survey from 'react/api/reducers/survey.js';
import ticketHub from 'react/api/reducers/ticketHub.js';
import ticketDetails from 'react/api/reducers/ticketDetails.js';
import chat from 'react/api/reducers/chat.js';
import wizard from 'react/api/reducers/wizard.js';
import samlConfiguration from 'react/api/reducers/samlConfiguration.js';
import chatTicketActions from 'react/api/reducers/chatTicketActions.js';
import integrations from 'react/api/reducers/integrations.js';
import footer from 'react/api/reducers/footer.js';
import toastAlerts from 'react/api/reducers/toastAlerts';
import routeDivisionModal from 'react/api/reducers/routeDivisionModal.js';
import wglnIntegrationLogs from 'react/api/reducers/wglnIntegrationLogs';
import modals from 'react/api/reducers/modals';
import eventHttpActionLogs from 'react/api/reducers/eventHttpActionLogs';
import configEventHttpHeadersModal from 'react/api/reducers/configEventHttpHeadersModal.js';
import quickAssignment from 'react/api/reducers/quickAssignment';
import localzIntegration from 'react/api/reducers/localzIntegration';
import localzIntegrationLogs from 'react/api/reducers/localzIntegrationLogs';
import sku from 'react/api/reducers/sku';
import alerts from 'react/api/reducers/alerts';
import photoAlbum from 'react/api/reducers/photoAlbum';
import bulkDownload from 'react/api/reducers/bulkDownload';
import header from 'react/api/reducers/header.js';
import routeDetails from 'react/api/reducers/routeDetails.js';

import { actions as authActions } from 'react/api/actions/auth';
import crud from 'react/api/reducers/crud.js';

const reducers = {
  routes,
  routeMonitor,
  filter,
  eventNotifications,
  pendingOrderAggregate,
  pendingOrders,
  auth,
  user,
  recoverPassword,
  passwordPolicies,
  i18n,
  configuration,
  features,
  tabs,
  modal,
  resequenceHistory,
  stopDetailsPopup,
  routeSummary,
  licenseStatusModal,
  taskScheduler,
  dashboardAnalytics,
  form,
  crud,
  routeSurveyModal,
  photoGallery,
  stockSummaryModal,
  survey,
  ticketHub,
  ticketDetails,
  chat,
  wizard,
  samlConfiguration,
  chatTicketActions,
  logoffAlertModal,
  integrations,
  footer,
  toastAlerts,
  routeDivisionModal,
  wglnIntegrationLogs,
  modals,
  eventHttpActionLogs,
  configEventHttpHeadersModal,
  quickAssignment,
  localzIntegration,
  localzIntegrationLogs,
  sku,
  alerts,
  photoAlbum,
  bulkDownload,
  header,
  routeDetails
};

const appReducer = combineReducers({
  router: connectRouter(history),
  ...reducers
});

const rootReducer = (state, action) => {
  if (action.type === authActions.logout) {
    Greenmile.Storage.clearUserData();
    Monet.I18n.clearUserData();

    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
